module.exports = {
          srcSet: __webpack_public_path__ + "1ae5c1aa9793993c392d371fbf67a221-1168.png"+" 1168w",
          images:[ {path: __webpack_public_path__ + "1ae5c1aa9793993c392d371fbf67a221-1168.png",width: 1168,height: 198}],
          src: __webpack_public_path__ + "1ae5c1aa9793993c392d371fbf67a221-1168.png",
          toString:function(){return __webpack_public_path__ + "1ae5c1aa9793993c392d371fbf67a221-1168.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAACCAYAAABhYU3QAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAXUlEQVR4nAFSAK3/ALsiJv3PNzz/3Dg//utBSP/5OkT/8yQq/uh2P//nSCv+w2pg/5k7NPsArxYZ9cEjJ//RJy3+4C41//EtN//3KCz+6V1B/ulCNv7IjYP/w5OK80uoLqvnp+o2AAAAAElFTkSuQmCC",
          width: 1168,
          height: 198
        }